<template>
	<div v-if="media" class="c-file-media flex-center" :title="fileName" @click="previewHandle">
		<video v-if="info.media == 'video'" :src="encodeSrc"></video>
		<img v-else-if="info.media == 'image'" :src="encodeSrc">
		<i v-else class="c-file-icon c-icon-file" :class="`c-icon-file-${info.suffix}`"></i>
	</div>
	<div v-else class="c-file flex-center-cross">
		<div class="c-file-thum flex-center">
			<img v-if="info.media == 'image'" :src="encodeSrc" alt="" @click="previewHandle">
			<i v-else class="tf-file" :class="`tf-file-${info.suffix}`"></i>
		</div>
		<div class="flex-grow">
			<p class="ellipsis">{{fileName}}</p>
			<div class="c-file-handle">
				<span @click="downloadHandle">下载</span>
				<span v-if="info.media || docType.includes(info.suffix.toLocaleLowerCase())" @click="previewHandle">浏览</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {cryptoJs} from '@deanwu/vue-component-library'
	
	export default {
		name: 'cFile',
		
		props: {
			src: String,
			media: Boolean,
			preview: {
				type: [Boolean, Array],
				default: true
			}
		},

		data() {
			return {
				docType: [
					'doc', 'dot', 'wps', 'wpt', 'docx', 'dotx', 'docm', 'dotm', 'rtf',
					'ppt', 'pptx', 'pptm', 'ppsx', 'ppsm', 'pps', 'potx', 'potm', 'dpt', 'dps',
					'xls', 'xlt', 'et', 'xlsx', 'xltx', 'csv', 'xlsm', 'xltm',
					'pdf'
				]
			}
		},

		computed: {
			info() {
				return this.parseFile(this.src);
			},

			fileName() {
				return `${this.info.name}${this.info.suffix ? '.' : ''}${this.info.suffix}`
			},

			encodeSrc() {
				return this.src.replaceAll(this.info.name, encodeURIComponent(this.info.name));
			},

			previewList() {
				return Array.isArray(this.preview) ? this.preview.filter(item => this.parseFile(item).media) : [];
			}
		},
		
		methods: {
			downloadHandle() {
				this.request({
					url: '/oss/weboffice/getPreViewUrl',
					data: {
						filepath: this.src,
						urlType: 1
					},
					loading: true,
					success: data => {
						window.open(data);
					}
				})
			},
			
			previewHandle() {
				if (!this.preview) {
					!this.media && this.downloadHandle();
					return;
				}
				if (this.info.media) {
					this.$preview({
						src: this.previewList.length ? this.previewList : this.encodeSrc,
						index: this.previewList.includes(this.src) ? this.previewList.indexOf(this.src) : 0
					});
				} else if (this.docType.includes(this.info.suffix.toLocaleLowerCase())) {
					window.open(`/doc?url=${encodeURIComponent(cryptoJs.AES.encrypt(this.src, 'doc').toString())}`);
				} else {
					this.downloadHandle();
				}
			}
		}
	}
</script>

<style lang="stylus">
</style>

<style lang="stylus" scoped>
	.c-file {
		gap: 10px;
		width: 100%;
		height: 44px;
		padding: 0 6px;
		background: #F9F9F9;
		
		&-media {
			box-sizing: border-box;
			width: 80px;
			height: 80px;
			border: 1px solid var(--unit-border);
			overflow: hidden;
			background: #fff;
			cursor: pointer;
			
			video {
				width: 100%;
				height: 100%;
				background: #000;
			}
		}
		
		&-icon {
			font-size: 18px;
		}
		
		&-thum {
			width: 32px;
			height: 32px;
			font-size: 28px;

			img {
				cursor: pointer;
			}
		}

		&-handle {
			span {
				margin-right: 10px;
				line-height: 18px;
				font-size: 12px;
				color: #0D6EFE;
				cursor: pointer;

				&:hover {
					text-decoration: underline;
				}
			}
		}

		p {
			line-height: 18px;
			font-size: 13px;
			color: #333;
		}
	}
</style>
